import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import Datatable from "../../Constants/Datatable";
import StoreContext from "./../../../Store/Context";
import { COLUMNS_CONSEJERIA, COLUMNS_CONSEJERIA_HABITOS } from "../../Constants/DatatableColumns";
import { Row, Col, TabContent, TabPane, Nav, NavItem, NavLink, Label, Input } from "reactstrap";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { SAVED_ICON, LOGOUT_ICON } from "./../../Constants/SrcImages";
import classnames from "classnames";
import { GET_DATE_MONTH_DAY,validateTokenStorage } from "./../../Constants/Util";
import { IConsejeriaPerson, IConsejeriaHabitos, IAsistencia, ISetup, IDataWeek } from "./../../Constants/Interfaces";
import {
  getSetup,
  getConsejerianByTeacher,
  getConsejerianHabitos,
  putHabitoBoletin,
  putHb_observacion,
  getAsistencia,
  putAsistant,
} from "../../Constants/Services";

interface IConsejeriaTeacherState {
  dataConsejeria: IConsejeriaPerson[];
  dataHabitos: IConsejeriaHabitos[];
  dataAsistencia: IAsistencia[];
  dataFormSetup: ISetup;
  formConsejeria: IConsejeriaPerson;
  isOpenHabitosAptitudes: boolean;
  isOpenAusenciasTardanza: boolean;
  isOpenConsejeria: boolean;
  activeTab: string;
  isOpenDropHabito: boolean;
  formHabito: {
    bh_id: string;
    bh_observacion: string;
  };
  dataWeek: IDataWeek[];
  mainInput: any;
}

class ConsejeriaTeacherState extends Component<RouteComponentProps<{}>, IConsejeriaTeacherState> {
  static contextType = StoreContext;
  constructor(props: any) {
    super(props);
    this.state = {
      dataConsejeria: [],
      dataAsistencia: [],
      dataWeek: [],
      dataHabitos: [],
      dataFormSetup: {
        set_registrationy: "",
        set_aniolectivo: "",
        set_startpactivo: new Date().toString(),
        set_endpactivo: new Date().toString(),
        set_start_ft: new Date().toString(),
        set_end_ft: new Date().toString(),
        set_start_st: new Date().toString(),
        set_end_st: new Date().toString(),
        set_start_tt: new Date().toString(),
        set_end_tt: new Date().toString(),
        set_trimestre: "",
      },
      formConsejeria: {
        per_id: "",
        per_cedula: "",
        per_name: "",
        per_lastname: "",
      },
      formHabito: {
        bh_id: "",
        bh_observacion: "",
      },
      isOpenDropHabito: false,
      isOpenHabitosAptitudes: false,
      isOpenAusenciasTardanza: false,
      isOpenConsejeria: true,
      activeTab: "1",
      mainInput: null,
    };

    this.fetchConsejeria = this.fetchConsejeria.bind(this);
    this.handlerSetDataEdit = this.handlerSetDataEdit.bind(this);
    this.handlerHabitosAptitudes = this.handlerHabitosAptitudes.bind(this);
    this.handlerAusenciasTardanzas = this.handlerAusenciasTardanzas.bind(this);
    this.handlerActiveTab = this.handlerActiveTab.bind(this);
    this.fetchConsejeriaHabitos = this.fetchConsejeriaHabitos.bind(this);
    this.dropHabito = this.dropHabito.bind(this);
    this.handlerSetDataEditHabit = this.handlerSetDataEditHabit.bind(this);
    this.onChangeObservacion = this.onChangeObservacion.bind(this);
    this.handlerSaveObservacion = this.handlerSaveObservacion.bind(this);
    this.observacionHabito = this.observacionHabito.bind(this);
    this.handlerCancelObservacion = this.handlerCancelObservacion.bind(this);
    this.handlerSetDataEditAsisten = this.handlerSetDataEditAsisten.bind(this);
    this.fetchSetup = this.fetchSetup.bind(this);
    this.setWeekStartEnd = this.setWeekStartEnd.bind(this);
  }

  async fetchConsejeria() {
    const response = await getConsejerianByTeacher(this.context.per_id);
    this.setState({
      dataConsejeria: response,
    });
  }

  async fetchAsistencia() {
    const response = await getAsistencia(this.context.per_id);

    this.setState({
      dataAsistencia: response,
    });
  }

  async fetchSetup() {
    const response = await getSetup();
    this.setState({
      dataFormSetup: response,
    });
  }

  async fetchConsejeriaHabitos() {
    const response = await getConsejerianHabitos(this.context.per_id);
    this.setState({
      dataHabitos: response,
    });
  }

  componentDidMount() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    this.fetchConsejeria();
    this.fetchConsejeriaHabitos();
    this.fetchAsistencia();
    this.fetchSetup();
  }

  handlerSetDataEdit(row: any) {
    this.setState({
      formConsejeria: row,
    });
  }

  handlerActiveTab(id: string) {
    this.setState({
      activeTab: id,
    });
    if (id === "3") {
      this.setWeekStartEnd();
    }
  }

  handlerConsejeria() {
    this.setState((prevState) => ({
      isOpenConsejeria: !prevState.isOpenConsejeria,
      isOpenHabitosAptitudes: false,
      isOpenAusenciasTardanza: false,
    }));
  }

  handlerHabitosAptitudes() {
    this.setState((prevState) => ({
      isOpenHabitosAptitudes: !prevState.isOpenHabitosAptitudes,
      isOpenAusenciasTardanza: false,
      isOpenConsejeria: false,
    }));
  }

  handlerAusenciasTardanzas() {
    this.setState((prevState) => ({
      isOpenAusenciasTardanza: !prevState.isOpenAusenciasTardanza,
      isOpenHabitosAptitudes: false,
      isOpenConsejeria: false,
    }));
  }

  handlerSetDataEditAsisten(asi_asistant, bl_id, asi_id, asi_date, type) {
    let body = {
      asi_id,
      bl_id,
      asi_asistant,
      asi_date,
      type,
    };

    putAsistant(body);

    setTimeout(() => {
      this.fetchAsistencia();
    }, 500);
  }

  handlerSetDataEditHabit(hb_desc, bh_id, formatNameProperty) {
    let body = {
      bh_id,
      hb_desc,
      formatNameProperty,
    };

    putHabitoBoletin(body);

    setTimeout(() => {
      this.fetchConsejeriaHabitos();
    }, 500);
  }

  onChangeObservacion(e: any, bh_id: any) {
    this.setState({
      formHabito: {
        ...this.state.formHabito,
        bh_id,
        [e.target.name]: e.target.value,
      },
    });
  }
  handlerSaveObservacion(bh_id) {
    let body = {
      bh_id,
      bh_observacion: this.state.formHabito.bh_observacion,
    };

    putHb_observacion(body);

    setTimeout(() => {
      this.fetchConsejeriaHabitos();
    }, 500);
  }

  handlerCancelObservacion(e) {
    this.setState({
      formHabito: {
        bh_id: "",
        bh_observacion: "",
      },
    });
  }

  observacionHabito = (cell, row, rowIndex, formatExtraData) => {
    if (formatExtraData.observacion.length > 0 && row.bh_id === formatExtraData.bh_id) {
      return (
        <React.Fragment>
          <div className="d-flex">
            <Input
              type="text"
              name="bh_observacion"
              // id="bh_observacion"
              onChange={(e) => this.onChangeObservacion(e, row.bh_id)}
              value={formatExtraData.observacion}
              placeholder="Observación"
            />
            <img className="img-observation-handler" onClick={() => this.handlerSaveObservacion(row.bh_id)} src={SAVED_ICON} alt="" />
            <img className="img-observation-handler" onClick={this.handlerCancelObservacion} src={LOGOUT_ICON} alt="" />
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div className="d-flex">
            <Input
              type="text"
              name="bh_observacion"
              // id="bh_observacion"
              onChange={(e) => this.onChangeObservacion(e, row.bh_id)}
              value={row.bh_observacion}
              placeholder="Observación"
            />
            <img className="img-observation-handler" onClick={() => this.handlerSaveObservacion(row.bh_id)} src={SAVED_ICON} alt="" />
            <img className="img-observation-handler" onClick={this.handlerCancelObservacion} src={LOGOUT_ICON} alt="" />
          </div>
        </React.Fragment>
      );
    }
  };

  dropHabito = (cell, row, rowIndex, formatExtraData) => {
    return (
      <React.Fragment>
        <DropdownButton color="secundary" drop="down" title={cell}>
          <Dropdown.Item onClick={() => this.handlerSetDataEditHabit("S", row.bh_id, formatExtraData.dataField)}>S</Dropdown.Item>
          <Dropdown.Item onClick={() => this.handlerSetDataEditHabit("R", row.bh_id, formatExtraData.dataField)}>R</Dropdown.Item>
          <Dropdown.Item onClick={() => this.handlerSetDataEditHabit("X", row.bh_id, formatExtraData.dataField)}>X</Dropdown.Item>
        </DropdownButton>
      </React.Fragment>
    );
  };

  setWeekStartEnd() {
    const props = this.state;
    var dataStartTrimestre;
    var dataEndTrimestre;
    if (props.dataFormSetup.set_trimestre === "I") {
      dataStartTrimestre = props.dataFormSetup.set_start_ft;
      dataEndTrimestre = props.dataFormSetup.set_end_ft;
    } else if (props.dataFormSetup.set_trimestre === "II") {
      dataStartTrimestre = props.dataFormSetup.set_start_st;
      dataEndTrimestre = props.dataFormSetup.set_end_st;
    } else if (props.dataFormSetup.set_trimestre === "III") {
      dataStartTrimestre = props.dataFormSetup.set_start_tt;
      dataEndTrimestre = props.dataFormSetup.set_end_tt;
    }
    var daysMonth = GET_DATE_MONTH_DAY({ startDate: dataStartTrimestre, endDate: dataEndTrimestre });
    this.setState({
      dataWeek: daysMonth,
    });
  }

  render() {
    const props = this.state;
    var dataAsistant = {};

    props.dataAsistencia.map((data, i) => {
      if(data.asi_trimestre!==props.dataFormSetup.set_trimestre){
      data.asi_asistant= "";
      data.asi_date="";
      data.asi_id="";
      }
      if (dataAsistant[data.per_id]) {
        dataAsistant[data.per_id].push({
          per_id: data.per_id,
          per_name: data.per_name,
          bl_id: data.bl_id,
          asi_id: data.asi_id,
          asi_date: data.asi_date,
          asi_asistant: data.asi_asistant,
        });

      } else {

        dataAsistant = {
          ...dataAsistant,
          [data.per_id]: [
            {
              per_id: data.per_id,
              per_name: data.per_name,
              bl_id: data.bl_id,
              asi_id: data.asi_id,
              asi_date: data.asi_date,
              asi_asistant: data.asi_asistant,
            },
          ],
        };
      }
      return null;
    });

    return (
      <React.Fragment>
        <Row>
          <Col xs={12} className="text-center">
            <h5 className="font-weight-bold">Consejeria</h5>
          </Col>
        </Row>
        <Nav tabs>
          <NavItem className="padding-a-libreta">
            <NavLink
              className={classnames({ active: props.activeTab === "1" })}
              onClick={() => {
                this.handlerActiveTab("1");
              }}
            >
              Consejeria
            </NavLink>
          </NavItem>
          <NavItem className="padding-a-libreta">
            <NavLink
              className={classnames({ active: props.activeTab === "2" })}
              onClick={() => {
                this.handlerActiveTab("2");
              }}
            >
              Hábitos y aptitudes
            </NavLink>
          </NavItem>
          <NavItem className="padding-a-libreta">
            <NavLink
              className={classnames({ active: props.activeTab === "3" })}
              onClick={() => {
                this.handlerActiveTab("3");
              }}
            >
              Ausencias y tardanzas
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={props.activeTab}>
          <TabPane tabId="1">
            <Row id="consejeria_table">
              <Col sm={12}>
                {props.dataConsejeria.length > 0 ? (
                  <Datatable
                    data={props.dataConsejeria}
                    columns={COLUMNS_CONSEJERIA()}
                    keyProp="per_cedula"
                    exportD={false}
                    searchs={true}
                    selectRows={false}
                    optionSelectRow={null}
                  />
                ) : (
                  <Row>
                    <Col xs={12} className="text-center">
                      <Label className="font-weight-bold result-none">Sin Resultados</Label>
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="2">
            <Row id="consejeria-habitos-table">
              <Col sm={12} className="table-habitos">
               
                  {props.dataHabitos.length > 0 ? (
                     <div className="habito-container overflow-auto">
                    <Datatable
                      data={props.dataHabitos}
                      columns={COLUMNS_CONSEJERIA_HABITOS(
                        this.dropHabito,
                        this.observacionHabito,
                        props.formHabito.bh_id,
                        props.formHabito.bh_observacion
                      )}
                      keyProp="bh_id"
                      exportD={false}
                      searchs={true}
                      selectRows={false}
                      optionSelectRow={null}
                    />
                     </div>
                  ) : (
                    <Row>
                      <Col xs={12} className="text-center">
                        <Label className="font-weight-bold result-none">Sin Resultados</Label>
                      </Col>
                    </Row>
                  )}
               
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="3">
            <Row id="consejeria-asistencia" className="width-asistant-overflow">
              <Col xs={12} className="text-center table-asist mt-4">
                {props.dataAsistencia.length > 0 ? (
                  <table className="table  table-bordered" id="table-asistencia">
                    <thead className="column-dark">
                      <tr>
                        <th  className="static-col" ><Label className="m-table-asistant">NOMBRE ESTUDIANTES</Label></th>
                        {props.dataWeek.map((data, i) => {
                          return (
                            <th key={i} className="w-90px">
                              <Label className="date-title">
                              {data.title.toUpperCase()}
                              </Label>
                              
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(dataAsistant).map((key: any, i) => {
                        return (
                          <tr key={i}>
                            <th className="label-name-consejeria w-900px static-col" >
                              {/* className="fs-12px" */}
                              <Label className="pl-2 pt-2" >{dataAsistant[key].length > 0 ? dataAsistant[key][0].per_name : ""}</Label>
                            </th>
                            {props.dataWeek.map((data, r) => {
                              var exist = dataAsistant[key].find((e) => e.asi_date === data.date);
                              var boletin = dataAsistant[key].find((e) => e.bl_id.length > 0);
                              if (exist !== undefined) {
                                return (
                                  <th key={r}>
                                    <DropdownButton drop="down" title={exist.asi_asistant}>
                                      <Dropdown.Item onClick={() => this.handlerSetDataEditAsisten("A", exist.bl_id, exist.asi_id, data.date, "PUT")}>
                                        A
                                      </Dropdown.Item>
                                      <Dropdown.Item onClick={() => this.handlerSetDataEditAsisten("T", exist.bl_id, exist.asi_id, data.date, "PUT")}>
                                        T
                                      </Dropdown.Item>
                                      <Dropdown.Item onClick={() => this.handlerSetDataEditAsisten("", exist.bl_id, exist.asi_id, data.date, "PUT")}>
                                        X
                                      </Dropdown.Item>
                                    </DropdownButton>
                                  </th>
                                );
                              } else {
                                return (
                                  <th key={r}>
                                    <DropdownButton drop="down" title="">
                                      <Dropdown.Item onClick={() => this.handlerSetDataEditAsisten("A", boletin.bl_id, null, data.date, "POST")}>
                                        A
                                      </Dropdown.Item>
                                      <Dropdown.Item onClick={() => this.handlerSetDataEditAsisten("T", boletin.bl_id, null, data.date, "POST")}>
                                        T
                                      </Dropdown.Item>
                                      <Dropdown.Item onClick={() => this.handlerSetDataEditAsisten("X", boletin.bl_id, null, data.date, "POST")}>
                                        X
                                      </Dropdown.Item>
                                    </DropdownButton>
                                  </th>
                                );
                              }
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                ) : (
                  <Row>
                    <Col xs={12} className="text-center">
                      <Label className="font-weight-bold result-none">Sin Resultados</Label>
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </React.Fragment>
    );
  }
}

export default ConsejeriaTeacherState;
